import { createReducer, on } from '@ngrx/store';
import * as WebHookActions from './webhook-actions'
import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';


export const webHookFeatureKey = 'webHook';

export interface State extends EntityState<any>{
  webHookList: any[],
  failedTransactions: any[],
}

export const adapter: EntityAdapter<any> = createEntityAdapter<any>();

export const initialState: State = adapter.getInitialState({
  webHookList: [],
  failedTransactions: [],
});

export const reducer = createReducer(
    initialState,
    on(WebHookActions.loadWebHookListSuccess,(state,action) => {
        return {
            ...state,
            webHookList : action.webHookList,
        }
    }),
    on(WebHookActions.loadFailedTransactionsSuccess,(state,action) => {
        return {
            ...state,
            failedTransactions : action.failedTransactions,
        }
    }),
)